var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auditStatus !== 3)?_c('el-button',{attrs:{"type":"primary","disabled":_vm.ifDis || _vm.auditStatus === 1},on:{"click":_vm.submit}},[_vm._v("\n  提交审核\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }